import type { DiscoveredOrganization } from '@stytch/react/b2b'

/**
 * Stytch sets `primary_required` per member when the factor they signed in
 * with can't be exchanged into the organisation, and leaves it empty when it
 * can. We lean on that rather than the org's own settings, because Stytch
 * already accounts for break-glass members and every restricted combination.
 */
export const needsPrimaryAuth = ({
  primary_required
}: Pick<DiscoveredOrganization, 'primary_required'>) =>
  Boolean(primary_required)

const EXISTING_MEMBERSHIPS = [
  'active_member',
  'invited_member',
  'pending_member'
]

/**
 * Social sign-in is for members only. Stytch also offers workspaces the person
 * could join by email domain or OAuth tenant, which would create a member.
 */
export const isExistingMembership = ({
  membership
}: Pick<DiscoveredOrganization, 'membership'>) =>
  EXISTING_MEMBERSHIPS.includes(membership.type)
